import React, { createContext, useContext, useReducer } from 'react';
import { setModalDispatcher } from '../utils/ModalDispatcher';

// User 타입 정의
export interface Modal {
  inquiry: boolean;
  membership: boolean;
  login: boolean;
  userAlert: {
    open: boolean;
    type:
      | 'guest'
      | 'free'
      | 'local'
      | 'quotaDepleted'
      | 'quotaDepletedExpiring'
      | null;
  };
}

export type ModalAction =
  | {
      type:
        | 'I'
        | 'M'
        | 'MC1'
        | 'MC2'
        | 'LOGIN_MODAL'
        | 'LOGIN_MODAL_CLOSE'
        | 'USER_ALERT_CLOSE'
        | 'USER_ALERT_CLOSE_DETAIL';
    }
  | {
      type: 'USER_ALERT';
      payload:
        | 'guest'
        | 'free'
        | 'local'
        | 'quotaDepleted'
        | 'quotaDepletedExpiring';
    };

// Context의 기본 값 타입
interface ModalContextType {
  modal: Modal;
  // setModal: (modal: Modal | null) => void;
  modalDispatch: React.Dispatch<ModalAction>;
}

const ModalReducer = (state: Modal, action: ModalAction) => {
  switch (action.type) {
    case 'I':
      return { ...state, inquiry: !state.inquiry };
    case 'M':
      return { ...state, membership: !state.membership };
    case 'MC1':
      return { ...state, membership: true };
    case 'MC2':
      return { ...state, membership: false };
    case 'USER_ALERT':
      return { ...state, userAlert: { open: true, type: action.payload } };
    case 'USER_ALERT_CLOSE':
      return { ...state, userAlert: { ...state.userAlert, open: false } };
    case 'USER_ALERT_CLOSE_DETAIL':
      return { ...state, userAlert: { open: false, type: null } };
    case 'LOGIN_MODAL':
      return { ...state, login: true };
    case 'LOGIN_MODAL_CLOSE':
      return { ...state, login: false };

    default:
      return state;
  }
};

// Context 생성
const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Provider 컴포넌트
export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [modal, modalDispatch] = useReducer(ModalReducer, {
    inquiry: false,
    membership: false,
    login: false,
    userAlert: { open: false, type: null },
  });

  React.useEffect(() => {
    setModalDispatcher(modalDispatch);
  }, []);

  return (
    <ModalContext.Provider value={{ modal, modalDispatch }}>
      {children}
    </ModalContext.Provider>
  );
};

// Custom Hook
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
